// Client script entrypoint

import {Carousel} from 'carousel';
import {Navigation} from 'navigation';
import {Tabs} from 'tabs';

document.addEventListener('DOMContentLoaded', () => {

	// Init components
	Navigation.init();
	Tabs.init();
	Carousel.init();

});
